import { render } from "./FloatNotificationWrapper.vue?vue&type=template&id=572d13dc&scoped=true"
import script from "./FloatNotificationWrapper.vue?vue&type=script&lang=js"
export * from "./FloatNotificationWrapper.vue?vue&type=script&lang=js"

import "./FloatNotificationWrapper.vue?vue&type=style&index=0&id=572d13dc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572d13dc"]])

export default __exports__